import axios from 'axios'
import React, { useState } from 'react'
import { SchInfo, SchLoading, SchGap } from '../../shared/atoms'
import { SchCardItem, SchContentContainer, SchTextInput } from '../../shared/molecules'
import { BACKEND_URL } from '../../utils'
import Wrapper from './style'
import WarningIc from '../../../assets/icons/warning.svg'

const LaboratoryChecker = () => {
	const [value, setValue] = useState('')
	const [landId, setLandId] = useState(null)
	const [loading, setLoading] = useState(false)
	const [emptyState, setEmptyState] = useState(false)

	const [parts, setParts] = useState([])

	const onChangeInput = (e) => {
		const input = e.target.value.replace(/\D/g, "");
		setValue(input);
	}

	const onCheck = () => {
		if (value === '') {
			return
		} else {
			setLoading(true);
			axios
				.get(`${BACKEND_URL}/api/lab-helper/lab-parts?id=${value}`)
				.then(res => {
					const part = res.data;
					setParts(part);
					setLoading(false);
					setEmptyState(true);
					setLandId(value);
					setValue('')
				}).catch(err => {
					const error = err;
					console.log("error", error);
					setEmptyState(true);
				})
		}
	}

	const onKeyPressEnter = (e) => {
		if(e.key === "Enter") {
			onCheck();
		}
	}

	return (
		<Wrapper>
			<SchTextInput
				button
				onClick={onCheck}
				placeholder="Enter Scholarz ID [numeric]"
				value={value}
				onChange={onChangeInput}
				onKeyPress={onKeyPressEnter}
			/>
			<SchGap height={"calc(10px + 2vw)"}/>
			<SchContentContainer>
				{loading
					? <SchLoading>Loading</SchLoading>
					: parts.success ?
						<>
							<div className="top-info">
								<div className="id">
									Land Id: {landId}
								</div>
								<div className="lab-lv">
									Laboratory Lv: {parts.laboratoryLvl}
								</div>
								<div className="status">
									Status: {parts.active ? "Active" : "Inactive"}
								</div>
								<div className="capacity">
									Capacity: {parts.currentCapacity}/{parts.maxCapacity}
								</div>
							</div>
							<div className="traits-wrapper">
								{parts.base.map(item => {
									return (
										<SchCardItem
											key={item.id}
											amount={item.amount}
											img={`./assets/traits/base/${item.id}.png`}
											scholarzId={item.id}
											name={'Base'}
											active={parts.active}
											onClick={() => {}}
										/>
										)
									})
								}
								{parts.eyes.map(item => {
									return (
										<SchCardItem
											key={item.id}
											amount={item.amount}
											img={`./assets/traits/eyes/${item.id}.png`}
											scholarzId={item.id}
											name={"Eyes"}
											active={parts.active}
											onClick={() => {}}
										/>
										)
									})
								}
								{parts.headgear.map(item => {
									return (
										<SchCardItem
											key={item.id}
											amount={item.amount}
											img={`./assets/traits/headgear/${item.id}.png`}
											scholarzId={item.id}
											name={"Headgear"}
											active={parts.active}
											onClick={() => {}}
										/>
										)
									})
								}
								{parts.mouth.map(item => {
									return (
										<SchCardItem
											key={item.id}
											amount={item.amount}
											img={`./assets/traits/mouth/${item.id}.png`}
											scholarzId={item.id}
											name={"Mouth"}
											active={parts.active}
											onClick={() => {}}
										/>
										)
									})
								}
								{parts.outfit.map(item => {
									return (
										<SchCardItem
											key={item.id}
											amount={item.amount}
											img={`./assets/traits/outfit/${item.id}.png`}
											name={"Outfit"}
											scholarzId={item.id}
											active={parts.active}
											onClick={() => {}}
										/>
										)
									})
								}
							</div>
						</>
						: emptyState
								&& (
									<>
										<SchInfo
										icon={
											<img
												src={WarningIc}
												alt="icon"
											/>
										}
										text={parts.message}
										/>
									</>
								)
				}
			</SchContentContainer>
		</Wrapper>
	)
}

export default LaboratoryChecker
